// src/admin/pages/CreateUserModal.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import AdminModal from '../components/AdminModal.jsx';
import { createUser } from '../adminApi.js';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: RADII.controlInner,
  border: `1px solid ${COLORS.borderStrong}`, background: COLORS.surface,
  color: COLORS.ink, fontSize: '14px', boxSizing: 'border-box',
  outline: 'none', fontFamily: FONT_SANS,
};

const labelStyle = {
  display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px', fontWeight: 500,
};

export default function CreateUserModal({ open, onClose, onCreated }) {
  const { t } = useTranslation('admin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await createUser({ email, password });
      setEmail('');
      setPassword('');
      onCreated();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setEmail('');
    setPassword('');
    setError('');
    onClose();
  }

  return (
    <AdminModal open={open} onClose={handleClose} title={t('users.create')}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="cum-email" style={labelStyle}>{t('shared.email')}</label>
          <input id="cum-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required style={inputStyle} />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="cum-password" style={labelStyle}>{t('users.password')}</label>
          <div style={{ position: 'relative' }}>
            <input
              id="cum-password"
              type={showPw ? 'text' : 'password'}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
              style={{ ...inputStyle, paddingRight: '40px' }}
            />
            <button
              type="button"
              onClick={() => setShowPw(v => !v)}
              style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: COLORS.textSecondary }}
            >
              {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          <span style={{ fontSize: '11px', color: COLORS.textSecondary, marginTop: '4px', display: 'block' }}>{t('shared.minChars')}</span>
        </div>

        {error && (
          <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: RADII.controlInner, background: SEMANTIC.errore.bg, border: `1px solid ${SEMANTIC.errore.bg}`, color: SEMANTIC.errore.fg, fontSize: '13px' }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%', padding: '10px', borderRadius: RADII.controlInner, border: 'none',
            background: loading ? COLORS.borderStrong : COLORS.accent, color: COLORS.surface,
            fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? t('users.creating') : t('users.create')}
        </button>
      </form>
    </AdminModal>
  );
}
